import React from 'react';
import Icon from '../Icon';

const EligibilityBottomCTA = () => {
  const scrollToForm = () => {
    const el = document.querySelector('.form-card');
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top, behavior: 'smooth' });
  };
  return (
    <section className="elig-bottom-cta">
      <div className="container">
        <div>
          <h3>Ready to see what you could earn?</h3>
          <p>It takes 2 minutes. We'll do the rest.</p>
        </div>
        <button className="btn btn-primary btn-lg" onClick={scrollToForm}>
          Check Your Eligibility
          <Icon name="arrow-right" size={17} stroke={2.4} className="arrow"/>
        </button>
      </div>
    </section>
  );
};

export default EligibilityBottomCTA;
